export enum MenuStateType {
    Open = 1,
    Closed = 2,
    Float = 3
}
